const KEY = 'reconLastDealership';

export function readLastDealership() {
	try {
		const raw = localStorage.getItem(KEY);
		return raw ? JSON.parse(raw) : null;
	} catch {
		return null;
	}
}

export function writeLastDealership({ database, subdomain, id }) {
	localStorage.setItem(KEY, JSON.stringify({ database, subdomain, id }));
}

export function clearLastDealership() {
	localStorage.removeItem(KEY);
}
